import gql from 'graphql-tag';

const TriggerSyncMutation = gql`
  mutation TriggerWearableSync($provider: String!) {
    wearable {
      triggerSync(provider: $provider) {
        ... on BasicMutationSuccess {
          __typename
        }
        ... on Error {
          code
          name
          description
          __typename
        }
      }
    }
  }
`;

export default TriggerSyncMutation;
